import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";
import type { MediaChapter } from "@circle-react/types/MediaChapter";
import type { MediaSetting } from "@circle-react/types/MediaSetting";

import {
  reactQueryGet,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";

type MediaChapterPayload = Pick<MediaChapter, "title" | "start_time"> & {
  id?: number;
};

export interface UpdateMediaSettingsPayload {
  chapters?: MediaChapterPayload[];
  custom_thumbnail?: string | null;
  make_downloadable?: boolean;
  transcript?: {
    enabled?: boolean;
    selected_file?: "ai" | "user";
    user_webvtt_file?: string;
  };
}

const show = (id: string): Promise<MediaSetting> =>
  reactQueryGet(internalApi.mediaSettings.show({ id }));

const update = (
  id: string,
  payload: UpdateMediaSettingsPayload,
): Promise<MediaSetting> =>
  reactQueryPut(internalApi.mediaSettings.update({ id }), payload);

export const mediaSettingsApi = {
  show,
  update,
};
